import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Card, CardContent, Grid, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Autocomplete, CustomTextField, LoadingFakeText } from "@totalsoft/rocket-webapp-components-deprecated";
import { get, set } from "@totalsoft/change-tracking-react";
import { onTextBoxChange } from "utils/propertyChangeAdapters";
import { emptyString, emptyArray } from "constants/defaultValues";
import { useQueryWithErrorHandling } from "hooks/errorHandling";
import { LEGAL_FORM_VALUES_QUERY } from "features/common/queries";
import { legalForm } from "constants/queryTypes";
import { ArrowBack } from "@material-ui/icons";

function USCompanyData({ selectedClientLens, onBack }) {
  const { t } = useTranslation();

  const [legalFormValues, setLegalFormValues] = useState(emptyArray);

  const { loading } = useQueryWithErrorHandling(LEGAL_FORM_VALUES_QUERY, {
    variables: { type: legalForm },
    onCompleted: (data) => {
      setLegalFormValues(data.legalFormValues);
    },
  });

  if (loading) {
    return <LoadingFakeText lines={10} />;
  }

  return (
    <Card>
      <CardContent>
        <Typography variant="h4">{t("Client.CompanyData")}</Typography>
        <Grid container>
          <Grid item container spacing={2}>
            <Grid item xs={12} sm={3}>
              <CustomTextField
                fullWidth
                label={t("Client.CompanyName")}
                value={(selectedClientLens.companyName |> get) || emptyString}
                onChange={selectedClientLens.companyName |> set |> onTextBoxChange}
                required
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <Autocomplete
                value={selectedClientLens.legalFormId || emptyString}
                label={t("Client.LegalForm")}
                simpleValue={true}
                options={legalFormValues}
                valueKey="id"
                labelKey="name"
                onChange={selectedClientLens.legalFormId |> set}
                isClearable={true}
                required
                noOptionsText={t("General.AutocompleteNoOptions")}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <CustomTextField
                fullWidth
                label={t("Client.TaxIdNumber")}
                value={(selectedClientLens.taxId |> get) || emptyString}
                onChange={selectedClientLens.taxId |> set |> onTextBoxChange}
                required
              />
            </Grid>
          </Grid>
          <Grid item container spacing={2}>
            <Grid item xs={12} sm={3}>
              <CustomTextField
                fullWidth
                label={t("Client.Street1")}
                value={(selectedClientLens.street1 |> get) || emptyString}
                onChange={selectedClientLens.street1 |> set |> onTextBoxChange}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <CustomTextField
                fullWidth
                label={t("Client.Street2")}
                value={(selectedClientLens.street2 |> get) || emptyString}
                onChange={selectedClientLens.street2 |> set |> onTextBoxChange}
              />
            </Grid>
          </Grid>
          <Grid item container spacing={2}>
            <Grid item xs={12} sm={3}>
              <CustomTextField
                fullWidth
                label={t("Client.City")}
                value={(selectedClientLens.city |> get) || emptyString}
                onChange={selectedClientLens.city |> set |> onTextBoxChange}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <CustomTextField
                fullWidth
                label={t("Client.State")}
                value={(selectedClientLens.state |> get) || emptyString}
                onChange={selectedClientLens.state |> set |> onTextBoxChange}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <CustomTextField
                fullWidth
                label={t("Client.Zip")}
                value={(selectedClientLens.zip |> get) || emptyString}
                onChange={selectedClientLens.zip |> set |> onTextBoxChange}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item container justifyContent="flex-end">
          <Button
            id="createClient_BackToSearchBtn"
            right="true"
            variant="contained"
            color="primary"
            onClick={onBack}
            endIcon={<ArrowBack />}
          >
            {t("General.BackToSearch")}
          </Button>
        </Grid>
      </CardContent>
    </Card>
  );
}

USCompanyData.propTypes = {
  selectedClientLens: PropTypes.object.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default USCompanyData;
